<template>
  <div class="p-0 col-12 animated fadeIn">
    <div class="card">
      <div class="card-body p-0">
        <kendo-datasource ref="datacustomer"
            :transport-read="getCustomer"
            :batch='true'
            :page-size='limit'
            :page="page"
            :schema="customer"
            :server-paging='true'
            :server-sorting='true'
            :server-filtering='true'>
        </kendo-datasource>
        <kendo-grid ref="gridcustomer" :data-source-ref="'datacustomer'"
            :filterable='true'
            :pageable="{ pageSizes: [10, 15, 25, 50], buttonCount: 3, input: true }"
            :sortable='false'
            :resizable='true'>
          <kendo-grid-column :filterable="getFilterType()" field="type" title="Type" width="130px"
            template="<span class='d-block text-capitalize'>#= outbound_type.toLowerCase() #</span>"></kendo-grid-column>
          <kendo-grid-column :filterable="getFilterCS()" field="cs" title="Sales Person" width="150px"
            template="<span class='d-block text-capitalize'>#= cs_detail.code.toUpperCase() # - #= cs_detail.fullname.toLowerCase() #</span>"></kendo-grid-column>
          <kendo-grid-column :filterable="filters.name" field="name" title="Name" width="200px"
            template="<span class='d-block text-capitalize'>#= customer.name.toLowerCase() #</span>"></kendo-grid-column>
          <kendo-grid-column :filterable="filters.phone" field="phone" title="Phone" width="150px"
            template="<span class='d-block text-uppercase'>#= customer.phone #</span>"
            :min-screen-width="mdThreshold"></kendo-grid-column>
          <kendo-grid-column :filterable="filters.email" field="email" title="Email" width="100px"
            template="<span class='d-block'>#= customer.email.toLowerCase() #</span>"
            :min-screen-width="mdThreshold"></kendo-grid-column>
          <kendo-grid-column :filterable="filters.address" field="address" title="Address"
            template="<span class='d-block text-capitalize'>#= customer.address.toLowerCase() #</span>"
            :min-screen-width="mdThreshold"></kendo-grid-column>
        </kendo-grid>
      </div>
      <div class="card-footer text-right">
        <div class="btn-group">
          <button class="btn btn-secondary" type="button" @click="exportAddress">
            Export Data
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      button: {
        name: 'Add Sales',
        icon: 'fa fa-cart-plus',
        url: '/sales/add'
      },
      limit: 15,
      page: 1,
      mdThreshold: 900,
      filters: {
        name: {
          extra: false,
          operators: {
            string: { contain: 'contains', eq: 'exact' }
          }
        },
        email: {
          extra: false,
          operators: {
            string: { contain: 'contains', eq: 'exact' }
          }
        },
        phone: {
          extra: false,
          operators: {
            string: { contain: 'contains', eq: 'exact' }
          }
        },
        address: {
          extra: false,
          operators: {
            string: { contain: 'contains', eq: 'exact' }
          }
        }
      },
      customer: {
        data: 'results',
        total: 'count',
        parse: function (response) {
          var data = response.results
          for (var i = 0; i < data.length; i++) {
            if ('email' in data[i].customer) {
              // do nothing
            } else {
              var customer = {
                name: data[i].customer.name,
                phone: data[i].customer.phone,
                address: data[i].customer.address,
                email: '-'
              }
              data[i].customer = customer
            }
          }
          response.results = data
          console.log(response)
          return response
        }
      }
    }
  },
  created () {
    // change button
    this.$parent.button = this.button
  },
  methods: {
    getCustomer (event) {
      var vm = this
      var limit = event.data.take
      var offset = event.data.skip
      var url = 'api/sales/customer/?limit=' + limit + '&offset=' + offset
      // apply filters if any
      var filters = []
      if (event.data.filter) {
        filters = event.data.filter.filters
      }
      var filter = ''
      for (var i = 0; i < filters.length; i++) {
        var tempFilter = filters[i]
        if (tempFilter.field === 'date') {
          tempFilter.value = moment(tempFilter.value).format('YYYY-MM-DD')
        }
        filter += '&' + tempFilter.field + '=' + encodeURIComponent(tempFilter.value + ';' + tempFilter.operator)
      }
      if (filter.length > 0) {
        url += filter
      }
      vm.axios.get(url)
        .then(
          (response) => {
            event.success(response.data)
          }
        )
        .catch(
          (error) => {
            console.log(error)
          }
        )
    },
    exportData () {
      // do something
    },
    exportAddress () {
      this.axios.get('api/sales/customer/export/address/', { responseType: 'arraybuffer' })
        .then(
          (response) => {
            var blob = new Blob([response.data], { type: response.headers['content-type'] })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'SBU Customer Address.xls'
            link.click()
          }
        )
        .catch(
          (error) => {
            console.log(error.response)
          }
        )
    },
    getFilterType () {
      var vm = this
      return {
        extra: false,
        operators: {
          string: { eq: 'equal to', neq: 'not equal to' }
        },
        ui: function (element) {
          element.kendoDropDownList({
            dataSource: {
              serverFiltering: false,
              transport: {
                read: function (event) {
                  vm.axios.get('api/inventory/outbound/type/')
                    .then(
                      (response) => {
                        event.success(response.data)
                      }
                    )
                }
              }
            },
            dataTextField: 'name',
            dataValueField: 'name'
          })
        }
      }
    },
    getFilterCS () {
      var vm = this
      return {
        extra: false,
        operators: {
          string: { eq: 'equal to', neq: 'not equal to' }
        },
        ui: function (element) {
          element.kendoMultiSelect({
            optionLabel: '-- select cs --',
            dataTextField: 'name',
            dataValueField: 'code',
            valuePrimitive: true,
            dataSource: {
              serverFiltering: true,
              transport: {
                read: function (event) {
                  vm.axios.get('api/user/account/')
                    .then(
                      (response) => {
                        event.success(response)
                      }
                    )
                }
              },
              schema: {
                data: 'data',
                parse: function (response) {
                  console.log(response)
                  var datas = []
                  var data = response.data
                  for (var i = 0; i < data.length; i++) {
                    var temp = data[i]
                    var cs = {
                      code: temp.code.toString(),
                      name: temp.fullname.toString()
                    }
                    datas.push(cs)
                  }
                  response.data = datas
                  return response
                }
              }
            }
          })
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/customer/Customer.vue